module.exports = __webpack_public_path__ + "assets/img/code.55ecf99b.png";